export type NewsItem = {
  date: string;
  category: string;
  title: string;
};

export const newsItems: NewsItem[] = [
  {
    date: '18 septembre 2026',
    category: 'Analyse',
    title: 'Après le NPNRU : quelles perspectives pour les quartiers prioritaires au-delà de 2030 ?',
  },
  {
    date: '2 juillet 2026',
    category: 'Publication',
    title: 'Copropriétés fragiles : retour sur dix ans de dispositifs d’intervention publique',
  },
  {
    date: '12 mai 2026',
    category: 'Cabinet',
    title: 'Ancrages retenu pour accompagner l’élaboration du PLH d’une métropole de l’Ouest',
  },
];
